// ** Next imports
import Image from "next/image";

// ** File imports
import Layout, { SEOHead } from "../../layouts/default";
import { FaqTemplate, FaqP } from "../../components/support/faqPages";

// ** Img Imports
import rscImg from "../../../public/images/rsc.jpg";

const RequestSpeedChange = () => (
  <Layout>
    <SEOHead title="Request Speed / Plan Change" />
    <FaqTemplate title="Request Speed / Plan Change">
      <FaqP>
        Need to adjust your speed? We can help you with that! Reach out and let
        us know how we can help.
      </FaqP>

      <Image
        className="img-fluid"
        placeholder="blur"
        src={rscImg}
        alt="Request Speed Plan Change"
      />
    </FaqTemplate>
  </Layout>
);

export default RequestSpeedChange;
